import React from 'react';
import { INewsListRequest } from '../../api/news';
import Filters from '../../components/Filter';
import { Input, BoolSelect, DateField, Select } from '../../components/Form';
import { IGroup } from '../../api/groups';

export const defaultFilter: INewsListRequest = {
  name: undefined,
  updatedAfter: undefined,
  updatedBefore: undefined,
  active: undefined,
  groups: undefined
}

interface IProps {
  filter: INewsListRequest;
  onApply: (filter: INewsListRequest) => void;
  groups: IGroup[];
}

export default function NewsFilter({ filter, onApply, groups }: IProps) {
  const handleSubmit = (values: INewsListRequest) => {
    // Transform groups to array of numbers before applying filter
    const transformedFilter = {
      ...values,
      // empty values omitted by react-final-form so the hack here
      title: values.title ? values.title.trim() : undefined,
      groups: values.groups?.map(id => Number(id))
    };

    onApply(transformedFilter);
  };

  return (
    <Filters initial={filter} onSubmit={handleSubmit}>
      <DateField name="updatedAfter" label="Изменена после" />
      <DateField name="updatedBefore" label="Изменена до" />
      <Input name="title" label="Заголовок" margin="dense" />
      <Select
        name="groups"
        label="Группы"
        options={groups.map((g) => ({ value: g.id, label: g.name }))}
        multi
        margin="dense"
      />
      <BoolSelect name="active" label="Активна" margin="dense" />
    </Filters>
  )
}
